import {
  getWarehouseList,
  postDraft,
  postSubmit,
  getInboundList,
  getInboundDetail,
  cancelInbound,
  editSku,
  getInboundDocument,
  getInboundHistory,
  getInventoryList,
  getInventoryDetail,
  getInventoryHistory,
  downloadFileSKU,
  moveStorage,
  downloadFileInventory,
  multipleSkuUpload,
  supportingDocumentUpload,
  downloadOutStorageReport
} from '@/api/warehouse.api.js'

export const FETCH_WAREHOUSE_LIST = 'FETCH_WAREHOUSE_LIST'
export const FETCH_WAREHOUSE_LIST_LOADING = 'FETCH_WAREHOUSE_LIST_LOADING'
export const FETCH_WAREHOUSE_LIST_DONE = 'FETCH_WAREHOUSE_LIST_DONE'
export const FETCH_WAREHOUSE_LIST_ERROR = 'FETCH_WAREHOUSE_LIST_ERROR'

export const POST_WAREHOUSE_DRAFT = 'POST_WAREHOUSE_DRAFT'
export const POST_WAREHOUSE_DRAFT_LOADING = 'POST_WAREHOUSE_DRAFT_LOADING'
export const POST_WAREHOUSE_DRAFT_DONE = 'POST_WAREHOUSE_DRAFT_DONE'
export const POST_WAREHOUSE_DRAFT_ERROR = 'POST_WAREHOUSE_DRAFT_ERROR'

export const POST_WAREHOUSE_SUBMIT = 'POST_WAREHOUSE_SUBMIT'
export const POST_WAREHOUSE_SUBMIT_LOADING = 'POST_WAREHOUSE_SUBMIT_LOADING'
export const POST_WAREHOUSE_SUBMIT_DONE = 'POST_WAREHOUSE_SUBMIT_DONE'
export const POST_WAREHOUSE_SUBMIT_ERROR = 'POST_WAREHOUSE_SUBMIT_ERROR'

export const FETCH_INBOUND_LIST = 'FETCH_INBOUND_LIST'
export const FETCH_INBOUND_LIST_LOADING = 'FETCH_INBOUND_LIST_LOADING'
export const FETCH_INBOUND_LIST_DONE = 'FETCH_INBOUND_LIST_DONE'
export const FETCH_INBOUND_LIST_ERROR = 'FETCH_INBOUND_LIST_ERROR'

export const FETCH_SKU_DETAIL = 'FETCH_SKU_DETAIL'
export const FETCH_SKU_DETAIL_LOADING = 'FETCH_SKU_DETAIL_LOADING'
export const FETCH_SKU_DETAIL_DONE = 'FETCH_SKU_DETAIL_DONE'
export const FETCH_SKU_DETAIL_ERROR = 'FETCH_SKU_DETAIL_ERROR'

export const CANCEL_INBOUND = 'CANCEL_INBOUND'
export const CANCEL_INBOUND_LOADING = 'CANCEL_INBOUND_LOADING'
export const CANCEL_INBOUND_DONE = 'CANCEL_INBOUND_DONE'
export const CANCEL_INBOUND_ERROR = 'CANCEL_INBOUND_ERROR'

export const EDIT_SKU = 'EDIT_SKU'
export const EDIT_SKU_LOADING = 'EDIT_SKU_LOADING'
export const EDIT_SKU_DONE = 'EDIT_SKU_DONE'
export const EDIT_SKU_ERROR = 'EDIT_SKU_ERROR'

export const INBOUND_DOCUMENT = 'INBOUND_DOCUMENT'
export const INBOUND_DOCUMENT_LOADING = 'INBOUND_DOCUMENT_LOADING'
export const INBOUND_DOCUMENT_DONE = 'INBOUND_DOCUMENT_DONE'
export const INBOUND_DOCUMENT_ERROR = 'INBOUND_DOCUMENT_ERROR'

export const INBOUND_HISTORY = 'INBOUND_HISTORY'
export const INBOUND_HISTORY_LOADING = 'INBOUND_HISTORY_LOADING'
export const INBOUND_HISTORY_DONE = 'INBOUND_HISTORY_DONE'
export const INBOUND_HISTORY_ERROR = 'INBOUND_HISTORY_ERROR'

export const FETCH_INVENTORY_LIST = 'FETCH_INVENTORY_LIST'
export const FETCH_INVENTORY_LIST_LOADING = 'FETCH_INVENTORY_LIST_LOADING'
export const FETCH_INVENTORY_LIST_DONE = 'FETCH_INVENTORY_LIST_DONE'
export const FETCH_INVENTORY_LIST_ERROR = 'FETCH_INVENTORY_LIST_ERROR'

export const FETCH_INVENTORY_DETAIL = 'FETCH_INVENTORY_DETAIL'
export const FETCH_INVENTORY_DETAIL_LOADING = 'FETCH_INVENTORY_DETAIL_LOADING'
export const FETCH_INVENTORY_DETAIL_DONE = 'FETCH_INVENTORY_DETAIL_DONE'
export const FETCH_INVENTORY_DETAIL_ERROR = 'FETCH_INVENTORY_DETAIL_ERROR'

export const INVENTORY_HISTORY = 'INVENTORY_HISTORY'
export const INVENTORY_HISTORY_LOADING = 'INVENTORY_HISTORY_LOADING'
export const INVENTORY_HISTORY_DONE = 'INVENTORY_HISTORY_DONE'
export const INVENTORY_HISTORY_ERROR = 'INVENTORY_HISTORY_ERROR'

export const DOWNLOAD_SKU = 'DOWNLOAD_SKU'
export const DOWNLOAD_SKU_LOADING = 'DOWNLOAD_SKU_LOADING'
export const DOWNLOAD_SKU_DONE = 'DOWNLOAD_SKU_DONE'
export const DOWNLOAD_SKU_ERROR = 'DOWNLOAD_SKU_ERROR'

export const DOWNLOAD_FILE_INVENTORY = 'DOWNLOAD_FILE_INVENTORY'
export const DOWNLOAD_FILE_INVENTORY_LOADING = 'DOWNLOAD_FILE_INVENTORY_LOADING'
export const DOWNLOAD_FILE_INVENTORY_DONE = 'DOWNLOAD_FILE_INVENTORY_DONE'
export const DOWNLOAD_FILE_INVENTORY_ERROR = 'DOWNLOAD_FILE_INVENTORY_ERROR'

export const MOVE_INVENTORY = 'MOVE_INVENTORY'
export const MOVE_INVENTORY_LOADING = 'MOVE_INVENTORY_LOADING'
export const MOVE_INVENTORY_DONE = 'MOVE_INVENTORY_DONE'
export const MOVE_INVENTORY_ERROR = 'MOVE_INVENTORY_ERROR'

export const MULTIPLE_SKU_UPLOAD = 'MULTIPLE_SKU_UPLOAD'
export const MULTIPLE_SKU_UPLOAD_LOADING = 'MULTIPLE_SKU_UPLOAD_LOADING'
export const MULTIPLE_SKU_UPLOAD_DONE = 'MULTIPLE_SKU_UPLOAD_DONE'
export const MULTIPLE_SKU_UPLOAD_ERROR = 'MULTIPLE_SKU_UPLOAD_ERROR'

export const SUPPORTING_DOCUMENT_UPLOAD = 'SUPPORTING_DOCUMENT_UPLOAD'
export const SUPPORTING_DOCUMENT_UPLOAD_LOADING =
  'SUPPORTING_DOCUMENT_UPLOAD_LOADING'
export const SUPPORTING_DOCUMENT_UPLOAD_DONE = 'SUPPORTING_DOCUMENT_UPLOAD_DONE'
export const SUPPORTING_DOCUMENT_UPLOAD_ERROR =
  'SUPPORTING_DOCUMENT_UPLOAD_ERROR'

export const DOWNLOAD_OUT_STORAGE_REPORT = 'DOWNLOAD_OUT_STORAGE_REPORT'
export const DOWNLOAD_OUT_STORAGE_REPORT_LOADING =
  'DOWNLOAD_OUT_STORAGE_REPORT_LOADING'
export const DOWNLOAD_OUT_STORAGE_REPORT_DONE =
  'DOWNLOAD_OUT_STORAGE_REPORT_DONE'
export const DOWNLOAD_OUT_STORAGE_REPORT_ERROR =
  'DOWNLOAD_OUT_STORAGE_REPORT_ERROR'

export default {
  [FETCH_WAREHOUSE_LIST](context) {
    context.commit(FETCH_WAREHOUSE_LIST_LOADING)
    return getWarehouseList()
      .then(response => {
        context.commit(FETCH_WAREHOUSE_LIST_DONE, response.data)
      })
      .catch(error => {
        context.commit(FETCH_WAREHOUSE_LIST_ERROR, error)
      })
  },

  [POST_WAREHOUSE_DRAFT](context, payload) {
    context.commit(POST_WAREHOUSE_DRAFT_LOADING)
    return postDraft(payload)
      .then(response => {
        context.commit(POST_WAREHOUSE_DRAFT_DONE, response.data)
      })
      .catch(error => {
        context.commit(POST_WAREHOUSE_DRAFT_ERROR, error)
      })
  },

  [POST_WAREHOUSE_SUBMIT](context, payload) {
    context.commit(POST_WAREHOUSE_SUBMIT_LOADING)
    return postSubmit(payload)
      .then(response => {
        context.commit(POST_WAREHOUSE_SUBMIT_DONE, response.data)
      })
      .catch(error => {
        context.commit(POST_WAREHOUSE_SUBMIT_ERROR, error)
      })
  },

  [FETCH_INBOUND_LIST](context, { type, currentPage, perPage, filter }) {
    context.commit(FETCH_INBOUND_LIST_LOADING)
    return getInboundList(type, currentPage, perPage, filter)
      .then(response => {
        context.commit(FETCH_INBOUND_LIST_DONE, response)
      })
      .catch(error => {
        context.commit(FETCH_INBOUND_LIST_ERROR, error)
      })
  },

  [FETCH_SKU_DETAIL](context, { id, filter }) {
    context.commit(FETCH_SKU_DETAIL_LOADING)
    return getInboundDetail(id, filter)
      .then(response => {
        context.commit(FETCH_SKU_DETAIL_DONE, response.data)
      })
      .catch(error => {
        context.commit(FETCH_SKU_DETAIL_ERROR, error)
      })
  },

  [CANCEL_INBOUND](context, id) {
    context.commit(CANCEL_INBOUND_LOADING)
    return cancelInbound(id)
      .then(response => {
        context.commit(CANCEL_INBOUND_DONE, response.data)
      })
      .catch(error => {
        context.commit(CANCEL_INBOUND_ERROR, error)
      })
  },

  [EDIT_SKU](context, { id, formData }) {
    context.commit(EDIT_SKU_LOADING)
    return editSku(id, formData)
      .then(response => {
        context.commit(EDIT_SKU_DONE, response.data)
      })
      .catch(error => {
        context.commit(EDIT_SKU_ERROR, error)
      })
  },

  [INBOUND_DOCUMENT](context, id) {
    context.commit(INBOUND_DOCUMENT_LOADING)
    return getInboundDocument(id)
      .then(response => {
        context.commit(INBOUND_DOCUMENT_DONE, response.data)
      })
      .catch(error => {
        context.commit(INBOUND_DOCUMENT_ERROR, error)
      })
  },

  [INBOUND_HISTORY](context, id) {
    context.commit(INBOUND_HISTORY_LOADING)
    return getInboundHistory(id)
      .then(response => {
        context.commit(INBOUND_HISTORY_DONE, response.data)
      })
      .catch(error => {
        context.commit(INBOUND_HISTORY_ERROR, error)
      })
  },

  [FETCH_INVENTORY_LIST](context, { type, currentPage, perPage, filter }) {
    context.commit(FETCH_INVENTORY_LIST_LOADING)
    return getInventoryList(type, currentPage, perPage, filter)
      .then(response => {
        context.commit(FETCH_INVENTORY_LIST_DONE, response)
      })
      .catch(error => {
        context.commit(FETCH_INVENTORY_LIST_ERROR, error)
      })
  },

  [FETCH_INVENTORY_DETAIL](context, { id, filter }) {
    context.commit(FETCH_INVENTORY_DETAIL_LOADING)
    return getInventoryDetail(id, filter)
      .then(response => {
        context.commit(FETCH_INVENTORY_DETAIL_DONE, response.data)
      })
      .catch(error => {
        context.commit(FETCH_INVENTORY_DETAIL_ERROR, error)
      })
  },

  [INVENTORY_HISTORY](context, id) {
    context.commit(INVENTORY_HISTORY_LOADING)
    return getInventoryHistory(id)
      .then(response => {
        context.commit(INVENTORY_HISTORY_DONE, response.data)
      })
      .catch(error => {
        context.commit(INVENTORY_HISTORY_ERROR, error)
      })
  },

  [DOWNLOAD_SKU](context, { skuId, fileId, fileName }) {
    context.commit(DOWNLOAD_SKU_LOADING)
    return downloadFileSKU(skuId, fileId, fileName)
      .then(response => {
        context.commit(DOWNLOAD_SKU_DONE, response.data)
      })
      .catch(error => {
        context.commit(DOWNLOAD_SKU_ERROR, error)
      })
  },

  [MOVE_INVENTORY](context, { id, formData }) {
    context.commit(MOVE_INVENTORY_LOADING)
    return moveStorage(id, formData)
      .then(response => {
        context.commit(MOVE_INVENTORY_DONE, response.data)
      })
      .catch(error => {
        context.commit(MOVE_INVENTORY_ERROR, error)
      })
  },

  [DOWNLOAD_FILE_INVENTORY](context, { fileId, fileName, url, type }) {
    context.commit(DOWNLOAD_FILE_INVENTORY_LOADING)
    let urlDownload = url ? url : 'wms/inventory/download-file/'
    let typeDocument = type ? type : ''
    return downloadFileInventory(fileId, fileName, urlDownload, typeDocument)
      .then(response => {
        context.commit(DOWNLOAD_FILE_INVENTORY_DONE, response.data)
      })
      .catch(error => {
        context.commit(DOWNLOAD_FILE_INVENTORY_ERROR, error)
      })
  },

  [MULTIPLE_SKU_UPLOAD](context, formData) {
    context.commit(MULTIPLE_SKU_UPLOAD_LOADING)
    return multipleSkuUpload(formData)
      .then(response => {
        context.commit(MULTIPLE_SKU_UPLOAD_DONE, response.data)
      })
      .catch(error => {
        context.commit(MULTIPLE_SKU_UPLOAD_ERROR, error)
      })
  },

  [SUPPORTING_DOCUMENT_UPLOAD](context, { id, formData }) {
    context.commit(SUPPORTING_DOCUMENT_UPLOAD_LOADING)
    return supportingDocumentUpload(id, formData)
      .then(response => {
        context.commit(SUPPORTING_DOCUMENT_UPLOAD_DONE, response.data)
      })
      .catch(error => {
        context.commit(SUPPORTING_DOCUMENT_UPLOAD_ERROR, error)
      })
  },

  [DOWNLOAD_OUT_STORAGE_REPORT](context, { id, fileName }) {
    context.commit(DOWNLOAD_OUT_STORAGE_REPORT_LOADING)
    return downloadOutStorageReport(id, fileName)
      .then(response => {
        context.commit(DOWNLOAD_OUT_STORAGE_REPORT_DONE, response.data)
      })
      .catch(error => {
        context.commit(DOWNLOAD_OUT_STORAGE_REPORT_ERROR, error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/warehouse/actions.js